import { gql } from "../__generated__/gql";

export const SIGN_PENDING_CONTRACTS = gql(`
   mutation signPendingContracts($contractIds: [ID!]!) {
      signPendingContracts(contractIds: $contractIds) {
        scheduledCount
      }
    }
`);
